module.exports = __webpack_public_path__ + "static/img/logo1.72bc565.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/logo1.png
// module id = mp/M
// module chunks = 1